import { createContext, Dispatch, SetStateAction } from 'react'
import { initialQnEditState, QnEditStateProps } from 'states/QnState'

/**
 * 編集中項目の初期値
 */
export const initialEditingItemContext = initialQnEditState

export const EditingItemContext = createContext<EditingItemContextProps>([
  initialEditingItemContext,
  (): void => {
    // 初期値として空の関数を設定
  },
])

export type EditingItemContextProps = [
  QnEditStateProps,
  Dispatch<SetStateAction<QnEditStateProps>>
]
